module.exports = __webpack_public_path__ + "img/network.6cbfe1ac.jpg";